import { MediaType, PostItemFragment, Post, PostStatus, PostTiming, ThirdPartyPost } from '../../../models/graphql';
import { InstagramGridPostType } from '../../../models/post';

// Look through the media, seeing if there is first a valid thumbnail, if not then get the full size url. If there is neither, search the next media
export const getFirstValidThumbnailUrl = (post: InstagramGridPostType | undefined): string | undefined => {
  for (const media of post?.media || []) {
    if (media.thumbnailUrl && media.thumbnailUrl.trim() !== '') {
      return media.thumbnailUrl;
    }
    if (media.url && media.url.trim() !== '') {
      return media.url;
    }
  }
  return undefined;
};

export const isPostItemFragmentOrThirdPartyPost = (item: unknown): item is PostItemFragment | ThirdPartyPost => {
  return typeof item === 'object' && item !== null && ('id' in item || 'externalId' in item);
};

export const mapToInstagramGridPost = (post: Post | PostItemFragment | ThirdPartyPost): InstagramGridPostType => {
  if ('id' in post && post.__typename === 'Post') {
    // Handle PostItemFragment mapping
    return {
      id: post.id,
      status: post.status,
      timing: post.timing,
      datePosted: post.datePosted || '',
      calculatedLocalDateTime: post.calculatedLocalDateTime || '',
      category: post.category
        ? {
            id: post.category.id,
            color: post.category.color,
            name: post.category.name
          }
        : undefined,
      socialProfile: {
        id: post.socialProfile.id
      },
      media: [
        ...post.videos.map(video => ({
          url: video.url,
          thumbnailUrl: video.thumbnailUrl,
          type: MediaType.VIDEO
        })),
        ...post.photos.map(photo => ({
          url: photo.url,
          thumbnailUrl: photo.thumbnailUrl,
          type: MediaType.PHOTO
        }))
      ],
      postFragment: post
    };
  } else if ('externalId' in post && post.__typename === 'ThirdPartyPost') {
    // Handle ThirdPartyPost mapping
    return {
      id: post.externalId,
      status: PostStatus.PUBLISHED,
      timing: PostTiming.SCHEDULE,
      datePosted: post.createdAt,
      calculatedLocalDateTime: '', // Assuming this is not available for ThirdPartyPost
      category: undefined,
      socialProfile: {
        id: post.externalProfile.externalId ?? ''
      },
      media: post.media.map(media => ({
        url: media.url || '',
        thumbnailUrl: media.thumbnailUrl || '',
        type: media.type === 'PHOTO' ? MediaType.PHOTO : MediaType.VIDEO
      }))
    };
  } else {
    throw new Error('Unsupported post type');
  }
};
